import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { BaseHandler } from '../../../graphql-orchestrator-link';
import { getTokenApisHeaders } from './tokenApiHeaders';
export class DeleteTokenHandler extends BaseHandler {
  constructor(mpacBaseUrl) {
    super();
    _defineProperty(this, "mpacBaseUrl", void 0);
    this.mpacBaseUrl = mpacBaseUrl;
  }
  async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
    const {
      addonKey,
      token
    } = operation.variables;
    const apiPath = "/".concat(addonKey, "/tokens/").concat(token);
    const resp = await fetchOk("".concat(this.mpacBaseUrl).concat(apiPath), {
      method: 'DELETE',
      headers: getTokenApisHeaders()
    }).then(response => response.json());
    return resp;
  }
  responseTransformer(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
    const {
      addonKey
    } = operation.variables;
    return {
      id: addonKey,
      tokenDetails: customResponse
    };
  }
}